// Start Custom_code_8 bundle buttons js
// =========================================================================
// 1. GRAB THE CONFIGURATION FROM SHOPIFY LIQUID
// =========================================================================
const isEn = window.BundleConfig.isEn;
const t = window.BundleConfig.t;
const PRODUCTS = window.BundleConfig.activeProducts;
const cartAddUrl = window.BundleConfig.cartAddUrl;
const cartUrl = window.BundleConfig.cartUrl;

// =========================================================================
// 2. GLOBAL STATE
// =========================================================================
let currentQty = 2; 
let unitSelections = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0 };
const API_KEY = "AIzaSyCli51lWX6MHxJW-F79DOBvvQTILz-DcoY"; 

// =========================================================================
// 3. INITIALIZATION & UI RENDERERS
// =========================================================================
document.addEventListener("DOMContentLoaded", function() {
  loadGoogleScript();
  renderAllRows();
});

function selectBundle(qty, element) {
  currentQty = parseInt(qty, 10);
  document.querySelectorAll('.bundle-card').forEach(el => {
    el.classList.remove('selected');
    el.querySelector('input').checked = false;
  });
  
  if(element) {
      element.classList.add('selected');
      element.querySelector('input').checked = true;
  }

  const customContainer = document.getElementById('custom-qty-wrapper');
  if(customContainer) customContainer.classList.remove('active');
  
  renderAllRows();
}

function enableCustomQty() {
  selectBundle(4, null); 
  const customContainer = document.getElementById('custom-qty-wrapper');
  customContainer.classList.add('active');
  const input = document.getElementById('custom-qty-input');
  input.value = 4;
  input.focus();
}

function updateCustomQty(inputElement) {
  let val = parseInt(inputElement.value, 10);
  if(isNaN(val) || val < 1) val = 1;
  if(val > 10) val = 10;
  
  inputElement.value = val;
  currentQty = val;
  renderAllRows();
}

function renderAllRows() {
  const container = document.getElementById('dynamic-inputs-container');
  container.innerHTML = ''; 

  for (let i = 1; i <= currentQty; i++) {
    const rowDiv = document.createElement('div');
    rowDiv.className = 'input-row';
    rowDiv.id = `row-wrapper-${i}`;

    let thumbsHtml = PRODUCTS.map((p, index) => {
        let isSelected = (unitSelections[i] === index) ? 'selected' : '';
        return `
          <div class="thumb-option ${isSelected}" id="thumb-${i}-${index}" onclick="handleProductChange(${i}, ${index})" title="${p.title}">
            <img src="${p.image}" alt="${p.title}">
          </div>
        `;
    }).join('');

    rowDiv.innerHTML = `
      <div class="unit-badge">${t.unit} ${i}</div>
      <div class="product-selector-label" id="product-label-${i}">${PRODUCTS[unitSelections[i]].title}</div>
      <div class="thumbnail-grid">${thumbsHtml}</div>
      <div id="same-wrapper-${i}" class="same-user-wrapper" style="display:none;">
        <input type="checkbox" id="same_as_first_${i}" checked onchange="toggleInput(${i})">
        <label for="same_as_first_${i}" id="same_label_${i}">${t.same_as_1st}</label>
      </div>
      <div class="input-area" id="input-area-${i}"></div>
      <div id="same-msg-${i}" class="same-msg">${t.same_address_msg}</div>
    `;

    container.appendChild(rowDiv);
    updateUnitUI(i); 
  }
}

function handleProductChange(unitIndex, productIndex) {
  unitSelections[unitIndex] = parseInt(productIndex, 10);
  updateUnitUI(unitIndex);
  if(unitIndex === 1) {
      for(let j = 2; j <= currentQty; j++) {
          updateUnitUI(j);
      }
  }
}

function updateUnitUI(i) {
  const prod = PRODUCTS[unitSelections[i]];
  const prodUnit1 = PRODUCTS[unitSelections[1]]; 

  const labelEl = document.getElementById(`product-label-${i}`);
  if(labelEl) labelEl.innerText = prod.title;

  document.querySelectorAll(`[id^="thumb-${i}-"]`).forEach(el => el.classList.remove('selected'));
  const activeThumb = document.getElementById(`thumb-${i}-${unitSelections[i]}`);
  if(activeThumb) activeThumb.classList.add('selected');

  const inputArea = document.getElementById(`input-area-${i}`);
  if (prod.inputType === 'google') {
    const svgIcon = `<svg class="google-icon" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#EA4335"/><circle cx="12" cy="9" r="2.5" fill="#fff"/></svg>`;
    inputArea.innerHTML = `
        <div style="position: relative; width: 100%;">
            ${svgIcon}
            <input type="text" id="dynamic-input-${i}" class="google-place-input" 
                   placeholder="${t.google_placeholder}" data-place-id="" data-index="${i}">
        </div>
        <div id="selected-card-${i}" class="selected-business-card"></div>
        <div class="business-disclaimer">${t.google_disclaimer}</div>
    `;
  } else {
    inputArea.innerHTML = `
        <div style="position: relative; width: 100%;">
            <img src="https://cdn.shopify.com/s/files/1/0898/1292/6797/files/instagram_icon_1.png?v=1771883502" class="insta-icon" alt="Instagram">
            <input type="text" id="dynamic-input-${i}" class="instagram-input" 
                   placeholder="${t.insta_placeholder}" data-index="${i}">
        </div>
    `;
  }

  if(i > 1) {
     const sameWrapper = document.getElementById(`same-wrapper-${i}`);
     const checkbox = document.getElementById(`same_as_first_${i}`);
     const label = document.getElementById(`same_label_${i}`);
     
     if(prod.inputType === prodUnit1.inputType) {
         sameWrapper.style.display = 'flex';
         label.innerText = prod.inputType === 'google' ? t.same_biz_1st : t.same_user_1st;
         toggleInput(i); 
     } else {
         sameWrapper.style.display = 'none';
         checkbox.checked = false; 
         inputArea.style.display = 'flex';
         document.getElementById(`same-msg-${i}`).style.display = 'none';
     }
  }

  setTimeout(() => {
    const inp = document.getElementById(`dynamic-input-${i}`);
    if(inp) {
      inp.addEventListener('input', function() { this.classList.remove('input-error'); });
      if(prod.inputType === 'google' && window.attachAutocomplete) {
        window.attachAutocomplete(inp);
      }
    }
  }, 50);
}

function toggleInput(index) {
  const checkbox = document.getElementById(`same_as_first_${index}`);
  const inputArea = document.getElementById(`input-area-${index}`);
  const sameMsg = document.getElementById(`same-msg-${index}`);
  const inp = document.getElementById(`dynamic-input-${index}`);
  
  if(checkbox && checkbox.checked) {
      inputArea.style.display = 'none';
      if(sameMsg) sameMsg.style.display = 'block';
      if(inp) inp.classList.remove('input-error');
  } else {
      inputArea.style.display = 'flex';
      if(sameMsg) sameMsg.style.display = 'none';
      if(inp) inp.focus();
  }
}

// =========================================================================
// 4. GOOGLE PLACES API
// =========================================================================
window.googleMapsLoaded = window.googleMapsLoaded || false;

function loadGoogleScript() {
  if (window.googleMapsLoaded) return;
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`;
  script.async = true; script.defer = true;
  script.onload = () => {
    window.googleMapsLoaded = true;
    for (let i = 1; i <= currentQty; i++) updateUnitUI(i); 
  };
  document.head.appendChild(script);
}

window.attachAutocomplete = function(inputElement) {
  if (!window.google || !window.google.maps || !window.google.maps.places) return;
    
  const autocomplete = new google.maps.places.Autocomplete(inputElement, {
    types: ['establishment'], 
    fields: ['name', 'formatted_address', 'place_id']
  });

  autocomplete.addListener('place_changed', function() {
    const place = autocomplete.getPlace();
    const index = inputElement.getAttribute('data-index');
    const prod = PRODUCTS[unitSelections[index]];

    if (place.name) {
      fetch("https://webhook-guard.replit.app/hook/google-places", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
              product: prod.webhookType,
              business_name: place.name,
              post_code: place.formatted_address || "Address not found", 
              google_place_id: place.place_id
          })
      }).catch(err => console.error("Webhook Error:", err));

      inputElement.value = place.name; 
      inputElement.setAttribute('data-place-id', place.place_id || "");
      inputElement.classList.remove('input-error');
      inputElement.classList.add('success');
        
      const wrapper = inputElement.parentElement;
      const icon = wrapper.querySelector('.google-icon');
      if(icon) icon.style.opacity = '0';

      const card = document.getElementById(`selected-card-${index}`);
      if(card) {
        card.innerHTML = `<strong>${place.name}</strong>${place.formatted_address}`;
        card.style.display = 'block';
      }

      inputElement.dispatchEvent(new Event('change'));
    }
  });
    
  inputElement.addEventListener('input', function() {
      if(this.value === "") {
         this.classList.remove('success');
         const index = this.getAttribute('data-index');
         const card = document.getElementById(`selected-card-${index}`);
         if(card) card.style.display = 'none';
         
         const wrapper = this.parentElement;
         const icon = wrapper.querySelector('.google-icon');
         if(icon) icon.style.opacity = '1';
      }
      this.classList.remove('input-error');
  });
};

// =========================================================================
// 5. ADD TO CART LOGIC & ERROR TRACKING
// =========================================================================
function addToCart() {
  const btn = document.getElementById('main-checkout-btn');
  var itemsToAdd = [];
  var firstInputValue = "";
  var firstPlaceId = "";

  document.querySelectorAll('[id^="dynamic-input-"]').forEach(el => el.classList.remove('input-error'));

  // 1. Validation Loop
  for(let i = 1; i <= currentQty; i++) {
      var inputEl = document.getElementById(`dynamic-input-${i}`);
      var prod = PRODUCTS[unitSelections[i]];
      var isInvalid = false;

      if (i === 1) {
          if (!inputEl || !inputEl.value.trim()) isInvalid = true;
      } else {
          var checkbox = document.getElementById(`same_as_first_${i}`);
          if((!checkbox || !checkbox.checked) && (!inputEl || !inputEl.value.trim())) {
              isInvalid = true;
          }
      }

      if(isInvalid) {
          inputEl.classList.add('input-error');
          inputEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          inputEl.focus();
          
          let errorMsg = "";
          if (prod.inputType === 'google') {
            errorMsg = `${t.err_google_1}${i}${t.err_google_2}`;
          } else {
            errorMsg = `${t.err_insta}${i}.`;
          }
          alert(errorMsg);

          // 🚨 TRACKING 1: Send validation errors to webhook before returning
          fetch("https://webhook-guard.replit.app/hook/error-log", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                  event: "frontend_validation_error",
                  error_message: errorMsg,
                  current_url: window.location.href,
                  user_agent: navigator.userAgent
              })
          }).catch(e => console.log("Silent fail on webhook log"));
          
          return; // Stop the function so it doesn't try to add to cart
      }
  }

  // 2. Format Items for Cart (no properties → identical variants merge into one line)
  // We still read the unit-1 values below so any "same as first" remarketing capture
  // logic elsewhere keeps working, but we intentionally DO NOT attach line-item
  // properties, so Shopify stacks identical variant IDs into a single cart line.
  var variantQtyMap = {};      // variantId -> merged quantity
  var orderedVariantIds = [];  // preserve first-seen order for a stable cart layout

  for(let i = 1; i <= currentQty; i++) {
      var prod = PRODUCTS[unitSelections[i]];

      // Capture the first unit's typed value (kept for parity with original flow;
      // business names are already sent to the remarketing webhook on selection).
      if (i === 1) {
          var firstInputEl = document.getElementById(`dynamic-input-1`);
          if (firstInputEl) {
              firstInputValue = firstInputEl.value;
              firstPlaceId = firstInputEl.getAttribute('data-place-id') || "";
          }
      }

      var vId = prod.variantId;
      if (variantQtyMap[vId] === undefined) {
          variantQtyMap[vId] = 0;
          orderedVariantIds.push(vId);
      }
      variantQtyMap[vId] += 1;
  }

  orderedVariantIds.forEach(function(vId) {
      itemsToAdd.push({
          'id': vId,
          'quantity': variantQtyMap[vId]
          // no 'properties' → identical variants merge; cart shows one line per variant
      });
  });

  // 3. Submitting to Cart & Shopify Error Tracking
  btn.disabled = true;
  btn.innerText = t.processing;

  fetch(cartAddUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: itemsToAdd })
  })
  .then(async (response) => { 
      // Catch actual Shopify server errors (like Out of Stock / 422)
      if (!response.ok) {
        const errData = await response.json().catch(() => ({})); // Safely parse error json
        throw new Error(errData.description || `Shopify Server Error: ${response.status}`);
      }
      window.location.href = cartUrl;
  })
  .catch((error) => { 
      console.error('Cart Error:', error);
      btn.disabled = false;
      btn.innerText = t.buy_now;
      
      // 🚨 TRACKING 2: Send the Shopify Server error straight to your Replit webhook
      fetch("https://webhook-guard.replit.app/hook/error-log", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
              event: "cart_add_error",
              error_message: error.message || "Unknown network error",
              items_attempted: itemsToAdd,
              current_url: window.location.href, 
              user_agent: navigator.userAgent
          })
      }).catch(e => console.log("Silent fail on webhook log")); 

      // TRACKING 3: Push to Google Analytics (if gtag is installed on the page)
      if (typeof gtag === 'function') {
          gtag('event', 'cart_error', {
              'event_category': 'Add to Cart',
              'event_label': error.message
          });
      }

      // Show a translation-friendly error to the customer
      const detailsLabel = isEn ? "Details: " : "Detalles: ";
      alert(`${t.err_network}\n\n${detailsLabel}${error.message || "Network Error"}`);
  });
}


// =========================================================================
// 6. BFCACHE RESET — restore button when user returns from cart (back button)
// =========================================================================
window.addEventListener('pageshow', function(event) {
  const navType = (performance.getEntriesByType('navigation')[0] || {}).type;
  if (event.persisted || navType === 'back_forward') {
    const btn = document.getElementById('main-checkout-btn');
    if (btn) {
      btn.disabled = false;
      btn.innerText = t.buy_now;
    }
  }
});
// End Custom_code_8 bundle buttons js